// extracted by mini-css-extract-plugin
module.exports = {"transparent":"Sidebar-module__transparent___o0jAZ"};